import OpportunityForm from '@/features/opportunities/form/OpportunityForm.tsx';
import { useGetMe } from '@/lib/api/me.ts';
import { useGetOpportunity } from '@/lib/api/opportunities.ts';
import { useParams } from 'react-router-dom';

const EditOpportunityPage = () => {
  const { data: userData } = useGetMe();
  const { id } = useParams();
  const { data: opportunity } = useGetOpportunity(Array.isArray(id) ? undefined : id);
  if (!userData || !opportunity) {
    return null;
  }
  return <OpportunityForm mode={'update'} opportunity={opportunity} />;
};

export default EditOpportunityPage;
